// extracted by mini-css-extract-plugin
module.exports = {"separator":"TouchpointQuestions_separator__FbTLF","questionTitle":"TouchpointQuestions_questionTitle__VUEjd"};